<template>
  <div class='ExportCard'>
    <search-form size='medium'
                 labelWidth='90px'
                 :searchData="search.searchData"
                 :searchForm="search.searchForm"
                 :searchHandle="search.searchHandle"
                 :searchHandleSpan="search.searchHandleSpan">
    </search-form>

    <Table :TableParam="Table">
      <template v-slot:issuingType="{ item }">
        <span>{{ $label.getLabel($label.SendTypes, item.issuingType) }}</span>
      </template>
      <template v-slot:cardNature="{ item }">
        <span>{{ $label.getLabel($label.CardTypes, item.cardNature) }}</span>
      </template>
      <template v-slot:Paging>
        <Paging @change="getItemList"
                :pager="pager" />
      </template>
    </Table>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import SearchForm from '@/components/SearchForm'
import Table from '@/components/Table'
import Paging from '@/components/Paging'
import { optionsDataReplace } from '@/utils'
const sexs = [{ label: '男', value: 'M' }, { label: '女', value: 'F' }]
const sexProps = { label: 'label', value: 'value' }
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {
    SearchForm,
    Table,
    Paging
  },
  data () {
    // 这里存放数据
    return {
      pager: { // 翻页
        page: 1,
        rows: 10,
        count: 0
      },

      search: { // 搜索
        searchData: {}, // 返回的数据
        searchForm: [
          { type: 'Input', label: '批次号：', prop: 'batchSn', placeholder: '请输入批次号' },
          { type: 'daterange', label: '售卡时间：', prop: 'daterange', span: 12 },
          { type: 'Select', label: '卡类型：', prop: 'cardTypeId', width: '180px', options: [], props: this.$map.typeProps, placeholder: '请选择卡类型' },
          { type: 'Select', label: '发行方式：', prop: 'issuingType', placeholder: '请选择发行方式', options: this.$label.SendTypes },
          { type: 'Input', label: '订单号：', prop: 'orderSn', placeholder: '请输入订单号' },
        ],
        searchHandle: [
          { label: '查询', type: 'primary', handle: () => this.searchHandleForm() },
          { label: '重置', handle: () => this.searchResetForm() }
        ],
        searchHandleSpan: 4
      },

      multipleSelection: [], // 选中的
      Table: { // 表格
        defaultBtn: {
          show: true,
          html: '导出',
          handle: () => this.defaultEvent()
        },
        data: [],
        column: [
          { prop: 'batchSn', label: '批次号' },
          { prop: 'issuingType', label: '发行方式', slot: true },
          { prop: 'cardName', label: '卡名称' },
          { prop: 'cardNo', label: '预付卡号' },
          { prop: 'cardType', label: '卡类型' },
          { prop: 'cardNatureStr', label: '卡种类' },
          { prop: 'denomination', label: '面值' },
          { prop: 'validDate', label: '有效期' },
          { prop: 'activatedTime', label: '售卡时间' },
          { prop: 'orderSn', label: '订单号' },
          { prop: 'activatedUserName', label: '售卡人员' }
        ]
      }
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    searchHandleForm () {
      this.getItemList()
    },

    searchResetForm () {
      this.search.searchData = {}
    },
    // 列表
    getItemList () {
      const { daterange } = this.search.searchData
      const { pager, Table } = this
      if (!daterange) {
        this.$message.warning('请选择售卡时间')
        return
      }
      const params = this.setParams()
      this.$http.getSellList(params)
        .then((res) => {
          if (res.status === 200) {
            pager.count = res.data.total
            Table.data = res.data.list
            this.$message.success(res.msg)
          } else {
            this.$message.error(res.msg)
          }
        })
    },
    // 导出
    defaultEvent () {
      const { daterange } = this.search.searchData
      if (!daterange) {
        this.$message.warning('请选择售卡时间')
        return
      }
      const params = this.setParams()
      this.$http.defaultsellList(params)
        .then((res) => {
          if (res.status === 200) {
            this.$message.success(res.msg)
          } else {
            this.$message.error(res.msg)
          }
        })
    },
    setParams () {
      const { batchSn, daterange, cardTypeId, issuingType, orderSn } = this.search.searchData
      const { pager } = this
      return {
        pageNum: pager.page,
        pageSize: pager.rows,
        'periodParam.beginDate': daterange ? daterange[0] : null,
        'periodParam.endDate': daterange ? daterange[1] : null,
        batchSn,
        cardTypeId,
        issuingType,
        orderSn
      }
    },
    // 卡类型
    async getCardTypeList () {
      const res = await this.$http.getCardTypeList()
      if(res && res.status === 200) {
        optionsDataReplace('cardTypeId', this.search.searchForm, (res.data || []))
      }
    },
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {
    this.getCardTypeList()
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {

  },
  beforeCreate () { }, // 生命周期 - 创建之前
  beforeMount () { }, // 生命周期 - 挂载之前
  beforeUpdate () { }, // 生命周期 - 更新之前
  updated () { }, // 生命周期 - 更新之后
  beforeDestroy () { }, // 生命周期 - 销毁之前
  destroyed () { }, // 生命周期 - 销毁完成
  activated () { } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
</style>
